/* Van project naar project zonder terug naar de lijst: vorige en volgende in de
 * volgorde die je in de projectlijst zag (anders op projectnummer), sneltoetsen
 * [ en ], en een zoekbare wisselaar. */

import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { buren, leesVolgorde } from '@/features/projectlijst/data/lijst';
import { useProjectenKort } from '@/features/projectlijst/hooks';
import { ProjectZoeker } from '@/features/projectlijst/ProjectZoeker';

export function ProjectNavigatie({ projectId }: { projectId: string }) {
  const navigate = useNavigate();
  const kort = useProjectenKort();
  const volgorde = leesVolgorde();
  /* De volgorde van de lijst zoals je hem zag; na een zoekopdracht met één treffer
     heeft vorige/volgende daar niets aan, dan alle projecten op nummer. */
  const uitLijst = Boolean(volgorde && volgorde.length > 1 && volgorde.includes(projectId));
  const lijst = uitLijst ? volgorde! : (kort.data ?? []).map((p) => p.id);
  const b = buren(lijst, projectId);

  useEffect(() => {
    const toets = (e: KeyboardEvent) => {
      const doel = e.target as HTMLElement;
      if (doel.tagName === 'INPUT' || doel.tagName === 'TEXTAREA' || doel.isContentEditable || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.key === '[' && b?.vorige) navigate(`/crm/projects/${b.vorige}`);
      if (e.key === ']' && b?.volgende) navigate(`/crm/projects/${b.volgende}`);
    };
    window.addEventListener('keydown', toets);
    return () => window.removeEventListener('keydown', toets);
  }, [b?.vorige, b?.volgende, navigate]);

  return (
    <div className="flex items-center gap-1">
      <Link to="/crm/projects" className="mr-1 inline-flex h-8 items-center gap-1.5 rounded-md px-2 text-sm text-muted-foreground hover:bg-muted hover:text-foreground">
        <ArrowLeft className="h-4 w-4" aria-hidden />
        Projecten
      </Link>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        disabled={!b?.vorige}
        onClick={() => b?.vorige && navigate(`/crm/projects/${b.vorige}`)}
        aria-label="Vorig project"
        title="Vorig project ( [ )"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      {b && (
        <span className="min-w-[48px] text-center text-xs tabular-nums text-muted-foreground" title={uitLijst ? 'Volgorde van je projectlijst' : 'Op projectnummer'}>
          {b.positie} / {b.totaal}
        </span>
      )}
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8"
        disabled={!b?.volgende}
        onClick={() => b?.volgende && navigate(`/crm/projects/${b.volgende}`)}
        aria-label="Volgend project"
        title="Volgend project ( ] )"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
      <ProjectZoeker />
    </div>
  );
}
